import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { spacing } from 'ui/theme';

export const StyledWarningBanner = styled(WarningBanner)`
  margin-top: ${spacing.fiveEights};
  margin-left: ${spacing.plusHalf};
`;
